var _rect, _circle, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementStaplesLandscapeWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 45,
    height: 60,
    rx: 2,
    transform: "rotate(90 60 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 23.5,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.804 30.5H36.828V22.772C36.828 20.868 36.828 16.724 31.088 16.724C28.96 16.724 26.86 17.368 25.376 18.88L27.14 20.644C28.036 19.804 29.324 19.244 30.724 19.244C32.516 19.244 33.804 20.112 33.804 21.764V22.128H32.964C29.604 22.128 24.508 22.436 24.508 26.804C24.508 29.464 26.916 30.836 29.408 30.836C31.2 30.836 32.768 30.164 33.72 28.652H33.804V30.5ZM33.608 25.236C33.608 27.112 32.516 28.316 30.22 28.316C29.128 28.316 27.868 27.784 27.868 26.552C27.868 24.62 31.06 24.48 32.908 24.48H33.608V25.236Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.75,
    y: 4.25,
    width: 1.5,
    height: 8,
    rx: 0.75,
    transform: "rotate(90 34.75 4.25)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.75,
    y: 4.25,
    width: 1.5,
    height: 8,
    rx: 0.75,
    transform: "rotate(90 54.75 4.25)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 4.25,
    width: 1.5,
    height: 8,
    rx: 0.75,
    transform: "rotate(90 13.75 4.25)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementStaplesLandscapeWidth);
export default __webpack_public_path__ + "static/media/placement-staples-landscape-width.5b22626eeba980b6d26ae4265fd0e3a2.svg";
export { ForwardRef as ReactComponent };